// Build the next URL safely, preserving filters/sort/view/search
function buildNextUrl(baseUrl, targetPage) {
  const current = new URL(window.location.href);
  const params = new URLSearchParams(current.search);

  // Copy current params but override `page`
  params.set('page', targetPage);

  // Derive path from baseUrl input (hidden input), fallback to pathname
  const path = baseUrl ? new URL(baseUrl, window.location.origin).pathname : window.location.pathname;

  return `${path}?${params.toString()}`;
}

// Update the URL bar without reload
function updateHistory(nextPage) {
  const current = new URL(window.location.href);
  const hadPage = current.searchParams.has('page');

  current.searchParams.set('page', nextPage);
  const newUrl = `${current.pathname}?${current.searchParams.toString()}`;

  if (!hadPage) {
    history.replaceState({ page: nextPage }, '', newUrl); // first time
  } else {
    history.pushState({ page: nextPage }, '', newUrl);    // subsequent times
  }
}

const loadItems = (button) => {
  const totalPages = parseInt($('[data-total-pages]').val());
  let currentPage = parseInt($('[data-current-page]').val());
  let currentPageScroll = currentPage + 1;

  currentPage = currentPage + 1;

  if (currentPage > totalPages) {
    button.remove();
    return;
  }
  // const nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/, 'page=' + currentPage);
  // const nextUrlScroll = $('[data-next-url]').val().replace(/page=[0-9]+/, 'page=' + currentPageScroll);

  const baseUrl = $('[data-next-url]').val();
  const nextUrl = buildNextUrl(baseUrl, currentPage);
  const nextUrlScroll = buildNextUrl(baseUrl, currentPageScroll);

  $('[data-current-page]').val(currentPage);

  button.setAttribute("disabled", "");
  button.classList.add('loading');

  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function (responseHTML) {
      // Запоминаем текущую позицию прокрутки
      const currentScrollTop = $(window).scrollTop();

      // Добавляем новые элементы
      $('.load-more-grid').append($(responseHTML).find('.load-more-grid').html());
      colorSwatches();

      // Восстанавливаем предыдущую позицию прокрутки
      $(window).scrollTop(currentScrollTop);
    },
    complete: function () {
      if (currentPage < totalPages) {
        const scollData = document.querySelector('.infinite-scroll__data');

        // const newUrl = `${window.location.pathname}?page=${currentPage}`
        // history.pushState({ page: currentPage }, '', newUrl);

        updateHistory(currentPage);
        
        if (scollData && currentPage != totalPages) {
          const nextUrlInput = scollData.querySelector('input[data-next-url]');
          const currentPageInput = scollData.querySelector('input[data-current-page]');
          if (nextUrlInput && currentPageInput) {
            nextUrlInput.dataset.nextUrl = nextUrlScroll;
            nextUrlInput.value = nextUrlScroll;
            currentPageInput.dataset.currentPage = currentPage;
            currentPageInput.value = currentPage;
          }
          checkVisibility();
        }
        button.removeAttribute("disabled");
        button.classList.remove('loading');
        if (currentPage == totalPages) {
          button.remove();
        }
      }
    }
  });
}

const checkVisibility = () => {
  const spinnerList = document.querySelectorAll('.js-infinite-scroll');
  spinnerList.forEach(spinner => {
    const sectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            loadItems(spinner);
          }
        })
      }
    );

    sectionObserver.observe(spinner);
  });
}

function loadMore() {
  document.querySelectorAll('.js-load-more').forEach((button) => {
    button.onclick = () => {
      loadItems(button);
    }
  });

  checkVisibility();
}

(function () {
  loadMore();
})();
